(function () {
  "use strict";

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'button:not([disabled]), iframe, [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && element.getAttribute("aria-hidden") !== "true";
    });
  }

  function appendAutoplay(url) {
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "autoplay=1";
  }

  function initVideoCenter(root) {
    if (root.dataset.vcInitialized === "true") return;
    root.dataset.vcInitialized = "true";

    var sid = root.dataset.vcSectionId;
    var dataEl = document.getElementById("vc-video-data-" + sid);
    var scenarioBarEl = root.querySelector("#vcScenarioBar-" + sid);
    var categoryBlockEl = root.querySelector("[data-vc-category-group]");
    var catBarEl = root.querySelector("#vcCatBar-" + sid);
    var modelBarEl = root.querySelector("#vcModelBar-" + sid);
    var modelScroll = root.querySelector("#vcModelScroll-" + sid);
    var gridEl = root.querySelector("#vcGrid-" + sid);
    var gridEmptyEl = root.querySelector("#vcGridEmpty-" + sid);
    var modal = document.getElementById("vcModal-" + sid);
    var iframe = document.getElementById("vcModalIframe-" + sid);
    var closeBtn = document.getElementById("vcModalClose-" + sid);
    var focusStart = modal && modal.querySelector("[data-vc-focus-start]");
    var focusEnd = modal && modal.querySelector("[data-vc-focus-end]");

    if (!dataEl || !scenarioBarEl || !categoryBlockEl || !catBarEl || !modelBarEl || !modelScroll || !gridEl || !gridEmptyEl || !modal || !iframe || !closeBtn || !focusStart || !focusEnd) {
      return;
    }

    var autoSelectFirst = root.dataset.vcAutoSelectFirst === "true";
    var flatVideos = [];

    try {
      flatVideos = JSON.parse(dataEl.textContent || "[]");
    } catch (error) {
      flatVideos = [];
    }

    function buildMaps(rows) {
      var videoData = {};
      var videos = [];
      var videoIndex = {};

      (rows || []).forEach(function (row) {
        if (!row || !row.category || !row.model) return;

        var id = String(row.youtube_id || "").split(/[?&]/)[0].trim();
        var hasVideo = id !== "";
        var embedBase = hasVideo ? "https://www.youtube.com/embed/" + id + "?rel=0" : "";
        var category = canonicalCategory(row.category);
        if (!videoData[category]) videoData[category] = {};
        videoData[category][row.model] = embedBase;

        var video = {
          category: category,
          model: row.model,
          hasVideo: hasVideo,
          thumbnail: hasVideo ? "https://img.youtube.com/vi/" + id + "/maxresdefault.jpg" : "",
          thumbnailFallback: hasVideo ? "https://img.youtube.com/vi/" + id + "/mqdefault.jpg" : "",
          url: embedBase
        };
        var key = category + "||" + row.model;
        if (typeof videoIndex[key] === "number") {
          videos[videoIndex[key]] = video;
        } else {
          videoIndex[key] = videos.length;
          videos.push(video);
        }
      });

      return { videoData: videoData, videos: videos };
    }

    var maps = buildMaps(flatVideos);
    var videoData = maps.videoData;
    var videos = maps.videos;
    var selectedScenario = null;
    var selectedCategory = null;
    var selectedModel = null;
    var lastFocusEl = null;

    // Keep the Installation Guide aligned with the four Shop by Need scenes.
    // Categories that are not in the current JSON are simply omitted from the UI.
    var scenarioDefinitions = [
      {
        name: "Bathroom Safety",
        description: "Showering, bathing and toilet support",
        categories: ["Shower Chair", "Toilet Safety Rails", "Raised Toilet Seat"]
      },
      {
        name: "Bedside Care",
        description: "Safer bed transfers and overnight routines",
        categories: ["Bedside Commodes", "Bed Rails"]
      },
      {
        name: "Mobility Support",
        description: "Everyday walking and rest support",
        categories: ["Rollator Walkers", "Standard Walkers", "Mobility Scooters"]
      },
      {
        name: "Recovery Mobility",
        description: "Hands-free movement during recovery",
        categories: ["Knee Scooter", "Walking Cane"]
      }
    ];

    function canonicalCategory(category) {
      return category === "Rolling Walkers" ? "Rollator Walkers" : category;
    }

    function normalizeModel(value) {
      return String(value || "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    }

    function findVideoByModel(model) {
      var requested = normalizeModel(model);
      if (!requested) return null;

      return (
        videos.find(function (video) {
          return normalizeModel(video.model) === requested;
        }) ||
        videos.find(function (video) {
          return normalizeModel(video.model)
            .split(/[^A-Z0-9]+/)
            .indexOf(requested) >= 0;
        }) ||
        videos.find(function (video) {
          return normalizeModel(video.model).indexOf(requested) === 0;
        }) ||
        null
      );
    }

    function setEmptyVisible(show) {
      gridEmptyEl.classList.toggle("is-visible", !!show);
    }

    function scenarioForCategory(category) {
      var definition = scenarioDefinitions.find(function (item) {
        return item.categories.indexOf(category) >= 0;
      });
      return definition ? definition.name : null;
    }

    function categoriesForScenario(scenario) {
      var definition = scenarioDefinitions.find(function (item) {
        return item.name === scenario;
      });
      if (!definition) return [];

      return definition.categories.filter(function (category) {
        return Object.prototype.hasOwnProperty.call(videoData, category);
      });
    }

    function availableScenarios() {
      return scenarioDefinitions
        .filter(function (definition) {
          return categoriesForScenario(definition.name).length > 0;
        })
        .map(function (definition) {
          return definition.name;
        });
    }

    function scenarioDefinition(scenario) {
      return scenarioDefinitions.find(function (definition) {
        return definition.name === scenario;
      });
    }

    function syncScenarioAria() {
      scenarioBarEl.querySelectorAll(".vc-scenario-btn").forEach(function (button) {
        button.setAttribute("aria-pressed", button.classList.contains("active") ? "true" : "false");
      });
    }

    function syncCategoryAria() {
      catBarEl.querySelectorAll(".vc-cat-btn").forEach(function (button) {
        button.setAttribute("aria-pressed", button.classList.contains("active") ? "true" : "false");
      });
    }

    function syncModelAria() {
      modelScroll.querySelectorAll(".vc-model-chip").forEach(function (chip) {
        chip.setAttribute("aria-pressed", chip.classList.contains("active") ? "true" : "false");
      });
    }

    function renderScenarios() {
      scenarioBarEl.innerHTML = "";
      availableScenarios().forEach(function (scenario) {
        var definition = scenarioDefinition(scenario);
        var button = document.createElement("button");
        button.type = "button";
        button.className = "vc-scenario-btn";
        button.dataset.scenario = scenario;
        button.innerHTML =
          '<span class="vc-scenario-btn__title">' + scenario + "</span>" +
          '<span class="vc-scenario-btn__description">' + (definition ? definition.description : "") + "</span>";
        button.setAttribute("aria-pressed", "false");

        button.addEventListener("click", function () {
          if (selectedScenario === scenario) {
            return;
          }

          selectedScenario = scenario;
          selectedCategory = null;
          selectedModel = null;
          scenarioBarEl.querySelectorAll(".vc-scenario-btn").forEach(function (item) {
            item.classList.remove("active");
          });
          button.classList.add("active");
          renderCategories();
          renderModels();
          renderVideos();
          syncScenarioAria();
        });

        scenarioBarEl.appendChild(button);
      });
    }

    function renderCategories() {
      catBarEl.innerHTML = "";
      var categories = categoriesForScenario(selectedScenario);
      categoryBlockEl.hidden = !selectedScenario || categories.length === 0;

      if (!selectedScenario || categories.length === 0) return;

      var allButton = document.createElement("button");
      allButton.type = "button";
      allButton.className = "vc-cat-btn vc-cat-btn--all";
      allButton.textContent = "All Products";
      allButton.setAttribute("aria-pressed", "true");
      if (!selectedCategory) allButton.classList.add("active");
      allButton.addEventListener("click", function () {
        selectedCategory = null;
        selectedModel = null;
        catBarEl.querySelectorAll(".vc-cat-btn").forEach(function (item) {
          item.classList.remove("active");
        });
        allButton.classList.add("active");
        renderModels();
        renderVideos();
        syncCategoryAria();
      });
      catBarEl.appendChild(allButton);

      categories.forEach(function (category) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "vc-cat-btn";
        button.textContent = category;
        button.setAttribute("aria-pressed", "false");

        button.addEventListener("click", function () {
          if (selectedCategory === category) {
            selectedCategory = null;
            selectedModel = null;
            renderModels();
            renderVideos();
            catBarEl.querySelectorAll(".vc-cat-btn").forEach(function (item) {
              item.classList.toggle("active", item === allButton);
            });
            syncCategoryAria();
            return;
          }

          selectedCategory = category;
          selectedModel = null;
          catBarEl.querySelectorAll(".vc-cat-btn").forEach(function (item) {
            item.classList.remove("active");
          });
          button.classList.add("active");
          renderModels();
          renderVideos();
          syncCategoryAria();
        });

        catBarEl.appendChild(button);
      });
    }

    function renderModels() {
      modelScroll.innerHTML = "";
      if (!selectedCategory) {
        modelBarEl.classList.remove("visible");
        return;
      }

      modelBarEl.classList.add("visible");
      Object.keys(videoData[selectedCategory]).forEach(function (model) {
        var chip = document.createElement("button");
        chip.type = "button";
        chip.className = "vc-model-chip";
        chip.textContent = model;
        chip.setAttribute("aria-pressed", "false");

        chip.addEventListener("click", function () {
          if (selectedModel === model) {
            selectedModel = null;
            chip.classList.remove("active");
            renderVideos();
            syncModelAria();
            return;
          }

          selectedModel = model;
          modelScroll.querySelectorAll(".vc-model-chip").forEach(function (item) {
            item.classList.remove("active");
          });
          chip.classList.add("active");
          renderVideos();
          syncModelAria();
        });

        modelScroll.appendChild(chip);
      });
    }

    var playIconSVG =
      '<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="32" cy="32" r="32" fill="white" fill-opacity="0.92"/>' +
      '<polygon points="26,20 26,44 46,32" fill="#004E92"/></svg>';

    function createVideoCard(video) {
      var hasVideo = video.hasVideo !== false && !!video.url;
      var card = document.createElement(hasVideo ? "button" : "div");
      if (hasVideo) card.type = "button";
      card.className = "vc-card" + (hasVideo ? "" : " vc-card--placeholder");
      card.setAttribute(
        "aria-label",
        hasVideo
          ? "Play installation video: " + video.category + " " + video.model
          : "Installation video coming soon: " + video.category + " " + video.model
      );

      var thumb = document.createElement("div");
      thumb.className = "vc-card-thumb";

      if (hasVideo) {
        var img = document.createElement("img");
        img.src = video.thumbnail;
        img.alt = "";
        img.loading = "lazy";
        img.addEventListener("error", function onThumbError() {
          img.removeEventListener("error", onThumbError);
          if (video.thumbnailFallback) img.src = video.thumbnailFallback;
        });

        var playIcon = document.createElement("div");
        playIcon.className = "vc-play-icon";
        playIcon.innerHTML = playIconSVG;

        thumb.appendChild(img);
        thumb.appendChild(playIcon);
      } else {
        thumb.classList.add("vc-card-thumb--placeholder");
        var placeholderText = document.createElement("span");
        placeholderText.className = "vc-card-thumb__placeholder-text";
        placeholderText.textContent = "Installation video coming soon";
        thumb.appendChild(placeholderText);
      }

      var meta = document.createElement("div");
      meta.className = "vc-card-meta";
      meta.innerHTML =
        '<span class="vc-card-model">' + video.model + "</span>" +
        '<span class="vc-card-name">' + video.category + "</span>";

      card.appendChild(thumb);
      card.appendChild(meta);

      function openFromCard() {
        openModal(video.url, video.category + " " + video.model + " — installation video");
      }

      if (hasVideo) {
        card.addEventListener("click", openFromCard);
        card.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          openFromCard();
        });
      } else {
        var status = document.createElement("span");
        status.className = "vc-card-status";
        status.textContent = "Video coming soon";
        meta.appendChild(status);
      }

      return card;
    }

    function renderVideos() {
      gridEl.innerHTML = "";
      if (!selectedScenario) {
        setEmptyVisible(!autoSelectFirst && Object.keys(videoData).length > 0);
        return;
      }

      var categories = selectedCategory ? [selectedCategory] : categoriesForScenario(selectedScenario);
      var totalMatches = 0;

      categories.forEach(function (category) {
        var list = videos.filter(function (video) {
          return video.category === category && (!selectedModel || video.model === selectedModel);
        });
        if (list.length === 0) return;

        var group = document.createElement("section");
        group.className = "vc-video-group";
        var heading = document.createElement("h3");
        heading.className = "vc-video-group__title";
        heading.textContent = category;
        group.appendChild(heading);

        var groupGrid = document.createElement("div");
        groupGrid.className = "vc-video-group__grid";
        list.forEach(function (video) {
          groupGrid.appendChild(createVideoCard(video));
        });
        group.appendChild(groupGrid);
        gridEl.appendChild(group);
        totalMatches += list.length;
      });

      setEmptyVisible(totalMatches === 0);
    }

    function closeModal() {
      if (!modal.classList.contains("active")) return;
      modal.classList.remove("active");
      modal.setAttribute("aria-hidden", "true");
      modal.hidden = true;
      iframe.src = "about:blank";
      iframe.title = "Installation video";
      document.body.classList.remove("vc-modal-open");

      if (lastFocusEl && typeof lastFocusEl.focus === "function") {
        lastFocusEl.focus();
      }
      lastFocusEl = null;
    }

    function openModal(url, titleText) {
      lastFocusEl = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      iframe.title = titleText || "Installation video";
      iframe.src = appendAutoplay(url);
      modal.hidden = false;
      modal.classList.add("active");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("vc-modal-open");
      closeBtn.focus();
    }

    function openRequestedVideo() {
      var params = new URLSearchParams(window.location.search || "");
      var requestedModel = params.get("product") || params.get("model") || "";
      var requestedVideo = findVideoByModel(requestedModel);
      if (!requestedVideo) return;

      selectedScenario = scenarioForCategory(requestedVideo.category);
      selectedCategory = requestedVideo.category;
      selectedModel = requestedVideo.model;

      renderScenarios();
      scenarioBarEl.querySelectorAll(".vc-scenario-btn").forEach(function (button) {
        button.classList.toggle("active", button.dataset.scenario === selectedScenario);
      });
      renderCategories();
      catBarEl.querySelectorAll(".vc-cat-btn").forEach(function (button) {
        button.classList.toggle("active", button.textContent === selectedCategory);
      });
      renderModels();
      modelScroll.querySelectorAll(".vc-model-chip").forEach(function (chip) {
        chip.classList.toggle("active", chip.textContent === selectedModel);
      });
      renderVideos();
      syncCategoryAria();
      syncModelAria();

        window.setTimeout(function () {
          if (typeof root.scrollIntoView === "function") {
            root.scrollIntoView({ behavior: "smooth", block: "start" });
          }
          if (requestedVideo.hasVideo) {
            window.setTimeout(function () {
              openModal(requestedVideo.url, requestedVideo.category + " " + requestedVideo.model + " — installation video");
            }, 180);
          }
        }, 80);
    }

    function handleFocusIn(event) {
      if (event.target === focusStart) {
        iframe.focus();
      } else if (event.target === focusEnd) {
        closeBtn.focus();
      }
    }

    function handleModalKeydown(event) {
      if (!modal.classList.contains("active")) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== "Tab") return;
      var focusable = getFocusableElements(modal);
      if (focusable.length === 0) {
        event.preventDefault();
        closeBtn.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener("focusin", handleFocusIn);
    modal.addEventListener("keydown", handleModalKeydown);

    renderScenarios();
    var scenarios = availableScenarios();
    if (autoSelectFirst && scenarios.length > 0) {
      selectedScenario = scenarios[0];
      var firstScenarioButton = scenarioBarEl.querySelector(".vc-scenario-btn");
      if (firstScenarioButton) firstScenarioButton.classList.add("active");
      renderCategories();
      selectedCategory = null;
      var firstButton = catBarEl.querySelector(".vc-cat-btn--all");
      if (firstButton) firstButton.classList.add("active");
      renderModels();
      renderVideos();
      syncScenarioAria();
      syncCategoryAria();
      syncModelAria();
    } else {
      renderCategories();
      setEmptyVisible(false);
      syncScenarioAria();
      syncCategoryAria();
    }

    openRequestedVideo();
  }

  function initializeAll() {
    document.querySelectorAll("[data-vc-video-center]").forEach(initVideoCenter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
